import React, { useState, useEffect, useRef } from 'react';
import { Translate } from '../../../language';
import { connect } from 'react-redux'
import {
    createLimitReport, editLimitReport,
    getLimitReports
} from '../../actions/reportActions';
import inMemoryJWT from '../../../auth/inMemoryJwt';
import ModalMenu from '../../../containers/ModalMenu';
import { ReactComponent as ViewIcon } from '../../../img/visibilidad.svg';
import { Field, Form, Formik, useFormik } from 'formik';
import Input from '../../../utils/components/Input/Input';

const SeeLimitisReportAdmin = ({ editLimitReport, getLimitReports, createLimitReport, listOfReportsLimit, isLoadingLimitOfReports, history }) => {


    const [error, setError] = useState({})
    const [isValidate, setValidate] = useState(false)
    const formikRef = useRef(null)

    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            getLimitReports()

        })

    }, [])
    const formik = useFormik({
        initialValues: {
            limitRejectedRequests: parseInt(listOfReportsLimit.limitRejectedRequests) || 0,
            limitAmountOfInfractions: parseInt(listOfReportsLimit.limitAmountOfInfractions) || 0,
            limitAmountOfReports: parseInt(listOfReportsLimit.limitAmountOfReports) || 0,
            shippingCost: parseInt(listOfReportsLimit.shippingCost) || 0,
            ecoPrice: parseInt(listOfReportsLimit.ecoPrice) || 0,
        },
        onSubmit: ({ limitAmountOfInfractions, limitAmountOfReports, limitRejectedRequests, shippingCost, ecoPrice }) => {
            console.log();
            // console.log();
            editLimitReport({ limitAmountOfInfractions, limitAmountOfReports, limitRejectedRequests, shippingCost, ecoPrice }, history)
        },
        enableReinitialize: true
    })



    return (
        <div className="container-admin-only-inputs">
            <div className='title-admin-list'>
                <div><ModalMenu
                    contentButton={
                        <div className=' wrapper-2'><div className=' ml-5 mr-5'>Editar Parámetros</div> <ViewIcon className="cls-1 mr-2" height="18" width="18" /></div>
                    }
                    contentModal={<div className='modal-options row'>
                        El Limite de infracciones indica la cantidad máxima de reportes que un post o una zona puede tener para que sea inhabilitada automáticamente y cuente como falta.
                        Dicha falta entrará en revisión por el usuario, el cual aceptará la falta o la mandará a revisión por parte del administrador (este determinará si se han infringido las normas).
                        El segundo campo para diligenciar, indica el número máximo de publicaciones o comunidades sancionadas (falta aceptada ya sea por el usuario o el administrador) que puede tener un usuario.
                        A modo de ejemplo: como se muestra, la primera opción tiene un valor de {formik.values.limitAmountOfReports}, es decir, que cuando {formik.values.limitAmountOfReports} usuarios reporten el post o la zona esta será inhabilitada y el usuario y/o administrador decidirá qué hacer.
                        Si {formik.values.limitAmountOfInfractions} publicaciones o comunidades han sido sancionadas esto contará como un strike.
                        Limite de solicitudes indica la cantidad máxima de soliciudes de ser EcoTienda o EcoMaster

                    </div>}
                /></div>

            </div>

            <div>
              
                <label>Limite de infracciones</label><Input type="number" className='inputs-admin input-admin-only-input' name="limitAmountOfInfractions"  onChange={formik.handleChange} value={formik.values.limitAmountOfInfractions}/>
                <label>Limite de reportes</label><Input type="number" className='inputs-admin input-admin-only-input' name="limitAmountOfReports"  onChange={formik.handleChange} value={formik.values.limitAmountOfReports}/>
                <label>Limite de solicitudes</label><Input type="number" className='inputs-admin input-admin-only-input' name="limitRejectedRequests" onChange={formik.handleChange} value={formik.values.limitRejectedRequests}/>
                <label>Costo de envió</label><Input type="number" className='inputs-admin input-admin-only-input' name="shippingCost"  onChange={formik.handleChange} value={formik.values.shippingCost}/>
                <label>Precio del Ecopunto</label><Input type="number" className='inputs-admin input-admin-only-input' name="ecoPrice"  onChange={formik.handleChange} value={formik.values.ecoPrice}/>
                <button type='submit' onClick={formik.handleSubmit}
                    className={isValidate ? 'btns-admin  btn-create-edit' : 'btns-admin btn-create-edit btn-inactive'} >Editar</button>
            </div>


        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        listOfReportsLimit: state.postAdmin.listOfReportsLimit,
        isLoadingLimitOfReports: state.postAdmin.isLoadingLimitOfReports,

    }
}
export default connect(mapStateToProps, { getLimitReports, editLimitReport, createLimitReport })(SeeLimitisReportAdmin) 
